import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *路演成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/ly`, { params })

/**
 *路演评分列表
 * @param params
 * 
*/

export const scoreList = params => Http.get(`${baseUrl}/sz/team/ly`, { params })

/**
 *新增评价项目
 * @param params
 * 
*/

export const addItem = params => Http.post(`${baseUrl}/sz/team/ly/item`, params )

/**
 *修改评价项目
 * @param params
 * 
*/

export const editItem = params => Http.put(`${baseUrl}/sz/team/ly/item`, params )

/**
 *删除评价项目
 * 
*/

export const delItem = ids => Http.delete(`${baseUrl}/sz/team/ly/item/${ids}` )

/**
 *评价项目列表
 * @param params
 * 
*/

export const itemList = params => Http.get(`${baseUrl}/sz/team/ly/item`, { params })

/**
 *评价项目排序
 * @param params
 * 
*/

export const sort = params => Http.put(`${baseUrl}/sz/team/ly/item/sort`,  params )

/**
 *评价项目类型列表
 * @param params
 * 
*/

export const itemTypeList = params => Http.get(`${baseUrl}/sz/team/ly/item/types`, { params })

/**
 *模板列表
 * @param params
 * 
*/

export const templateList = params => Http.get(`${baseUrl}/sz/team/ly/template`, { params })

/**
 *保存模板
 * @param params
 * 
*/

export const saveTemplate = params => Http.post(`${baseUrl}/sz/team/ly/template`, params )

/**
 *删除模板
 * 
*/

export const delTemplate = ids => Http.delete(`${baseUrl}/sz/team/ly/template/${ids}` )

/**
 *重置列表
 * @param classId
 * 
*/

export const resetList = classId => Http.post(`${baseUrl}/sz/team/ly/template/${classId}/reset`)
